export default __webpack_public_path__ + "static/gumGUm-b22840fd5178f02eed6302257cfc3c09.svg";